import { ref } from 'vue';

const flextimeProfilesHandler = () => {
  const flextimeProfiles_error = ref(null);
  const allFlextimeProfiles = ref(null);

  const loadAllFlextimeProfiles = async () => {
    try {
      let data = await fetch("/api/flextimeprofiles");

      if (!data.ok) {
        throw Error("Can't load data");
      }

      allFlextimeProfiles.value = await data.json();

      console.log('flextimeProfiles', allFlextimeProfiles.value);
    } catch (err) {
      flextimeProfiles_error.value = err.message;
    }
  }

  return { allFlextimeProfiles, flextimeProfiles_error, loadAllFlextimeProfiles };
};

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};

export default flextimeProfilesHandler;
